// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import TextContentModel from '../../model/text-content-model';
import TextContentDTO from '../dto/text-content-dto';
import dtoSchema from '../schemas/text-content-schema';
import ResourceLinkModel from '../../model/resource-link-model';
import TranslationOfTextContentModel from '../../model/translation-of-text-content-model';

export default abstract class TextContentModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<TextContentDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.textContentKey = data.textContentKey ?? undefined;
      this.scope = data.scope ?? undefined;
      this.originalContent = data.originalContent ?? undefined;
      this.originalLanguage = data.originalLanguage ?? undefined;
      this.translations = data.translations?.map((i) => TranslationOfTextContentModel.toModel(i)) ?? [];
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  textContentKey?: string;
  /**
  */
  scope?: string;
  /**
  */
  originalContent?: string;
  /**
  */
  originalLanguage?: string;
  /**
  */
  translations?: TranslationOfTextContentModel[];

  static toModel(dto: DeepPartial<TextContentDTO>): TextContentModel;
  static toModel(dto: DeepPartial<TextContentDTO> | undefined | null): TextContentModel | undefined;
  static toModel(dto: DeepPartial<TextContentDTO> | undefined | null): TextContentModel | undefined {
    return dto ? new TextContentModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<TextContentModel> | TextContentModel): TextContentDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      textContentKey: unwrapped.textContentKey,
      scope: unwrapped.scope,
      originalContent: unwrapped.originalContent,
      originalLanguage: unwrapped.originalLanguage,
      translations: unwrapped.translations,
    } as TextContentDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for TextContentModel, can not map to TextContentDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
